import { render } from "./v-top-nav-aside.vue?vue&type=template&id=37de406b"
import script from "./v-top-nav-aside.vue?vue&type=script&lang=js"
export * from "./v-top-nav-aside.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/datadrivet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__